/**
 * ref. https://github.com/getsentry/sentry-javascript/issues/2590
 *
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
export const browserPerformanceTimeOrigin = (() => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!performance || !performance.now) {
    return;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const now = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - now) : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - now) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      return performance.timeOrigin;
    }

    return navigationStart;
  }

  return now;
})();

export function getPerformanceNow() {
  try {
    if (browserPerformanceTimeOrigin) {
      const now = Date.now() - browserPerformanceTimeOrigin;
      return Math.floor(now);
    }

    if (performance.now) {
      return Math.floor(performance.now());
    }

    return null;
  } catch (error) {
    return null;
  }
}
